import "@/scripts/global/utils/LocalizationForm"
import "@/scripts/sections/FooterMenu.js"
import { formatMoney } from "@/scripts/global/utils/helpers"

import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import collapse from '@alpinejs/collapse'

import product_gallery from "@/scripts/templates/product/product_gallery"
import product_card from "@/scripts/templates/product/product-card"
import swiper from "@/scripts/components/swiper"
import klaviyo_newsletter from "@/scripts/sections/klaviyo-newsletter"
import faq from "@/scripts/sections/faq"
import blog from "@/scripts/sections/blog"
import heroCarousel from "@/scripts/sections/image-banner-carousel"
import accordion from "@/scripts/components/accordion"
import contact_form from "@/scripts/sections/contact_form"
import customer from "@/scripts/templates/customer/customer"
import splideSlider from "@/scripts/components/splide-slider";
import cart from "@/scripts/templates/cart/cart";

// Moved back to the global scope
import imageBanner from "@/scripts/sections/image_banner";
import navigation from "@/scripts/sections/navigation";



Alpine.plugin(focus)
Alpine.plugin(collapse)
window.Alpine = Alpine
window.formatMoney = formatMoney

document.addEventListener("alpine:init", () => {
  Alpine.data("swiper", swiper)
  Alpine.data("product_gallery", product_gallery)
  Alpine.store("cart", cart())
  Alpine.store("product_card", product_card())
  Alpine.data("klaviyo_newsletter", klaviyo_newsletter)
  Alpine.data("faq", faq)
  Alpine.data("blog", blog)
  Alpine.data("heroCarousel", heroCarousel)
  Alpine.data("accordion", accordion)
  Alpine.data("contact_form", contact_form)
  Alpine.data("customer", customer)
  Alpine.data("splide", splideSlider)

  // Moved back to the global scope
  Alpine.data("imageBanner", imageBanner);
  Alpine.data("navigation", navigation);
})

Alpine.start()


